import { initContract } from '@ts-rest/core';
import { z } from 'zod';

export const GetSettingsSchema = z.object({});

export const SettingsResultSchema = z.object({
  clientBaseUrl: z.string().optional(),
  walletEnabled: z.boolean(),
  highValuesIDMSEnabled: z.boolean(),
  aesEnabled: z.boolean(),
  reSendDelay: z.number(),
  transitEnabled: z.boolean(),
  temporaryStorageEnabled: z.boolean(),
  country: z.string(),
  isForwarder: z.boolean(),
  requestTime: z.string(),
  notificationsUrl: z.string(),
  frontendMonitoringKey: z.string().optional(),
  enableUtbReport: z.boolean(),
  isCatalogsTestEnv: z.boolean(),
  isObf: z.boolean(),
  lvInvoiceTreshold: z.number(),
  loggingProxyUrl: z.string().optional(),
});

export const GetCodesSchema = z.object({
  code: z.union([z.string(), z.array(z.string())]),
  search: z.coerce.string().optional(),
  locale: z.string(),
  system: z.union([z.string(), z.array(z.string())]).optional(),
});

export const CodesResultSchema = z.object({
  codes: z.array(
    z.object({
      value: z.string(),
      label: z.string(),
    }),
  ),
});

const c = initContract();

export const settingsContract = c.router({
  getSettings: {
    method: 'GET',
    path: '/settings',
    responses: { 200: SettingsResultSchema },
  },
  getCodes: {
    method: 'POST',
    path: '/settings/get-codes',
    body: GetCodesSchema,
    responses: { 201: CodesResultSchema },
  },
});
